import { render } from "./TakerZone.vue?vue&type=template&id=2e60cc93&scoped=true&ts=true"
import script from "./TakerZone.ts?vue&type=script&lang=ts"
export * from "./TakerZone.ts?vue&type=script&lang=ts"

import "./TakerZone.vue?vue&type=style&index=0&id=2e60cc93&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e60cc93"]])

export default __exports__